import { useConfiguredBlockExplorer } from '#/data/wagmi/configured';
import { cn } from '#/lib/utils';
import Link from 'next/link';
import { ComponentProps } from 'react';
import { Button } from './ui/button';

type ButtonProps = ComponentProps<'button'>;

interface Props extends ButtonProps {
  blockNumber?: bigint | number | null;
}

export default function EthereumBlockNumber({
  blockNumber,
  className,
  ...props
}: Props) {
  const blockExplorer = useConfiguredBlockExplorer();
  return blockNumber != null ? (
    <Button
      variant="link"
      size="sm"
      className={cn(
        'px-0 font-mono underline decoration-dashed decoration-gray-300 underline-offset-4',
        className
      )}
      asChild
      {...props}
    >
      <Link
        href={`${blockExplorer?.url}/block/${blockNumber}`}
        target="_blank"
        rel="noreferrer"
        prefetch={false}
      >
        #{String(blockNumber)}
      </Link>
    </Button>
  ) : (
    <>-</>
  );
}
